import { useMemo } from 'react';
import { AMBASSADOR_SALE_TYPE } from '@utils/enum';
import { CheckoutExperimentVariant, isCheckoutVariant } from '@utils/constants';

export const TARGET_CHECKOUT_VARIANTS = [
  CheckoutExperimentVariant.TARGET_ONE,
  CheckoutExperimentVariant.TARGET_TWO,
  CheckoutExperimentVariant.TARGET_THREE,
] as const;

type TargetVariant = (typeof TARGET_CHECKOUT_VARIANTS)[number];

const useCheckoutFlowVariant = () => {
  const variant = useMemo(() => {
    if (typeof window === 'undefined') return CheckoutExperimentVariant.CONTROL;
    const stored = sessionStorage.getItem(AMBASSADOR_SALE_TYPE.CHECKOUT_FLOW_VARIANT);
    return isCheckoutVariant(stored)
      ? stored
      : CheckoutExperimentVariant.CONTROL;
  }, []);

  return useMemo(() => {
    const is = (v: CheckoutExperimentVariant) => variant === v;

    return {
      variant,
      isControlCheckoutVariant: is(CheckoutExperimentVariant.CONTROL),
      isTargetCheckoutVariant: TARGET_CHECKOUT_VARIANTS.includes(
        variant as TargetVariant,
      ),
      isTargetOneCheckoutVariant: is(CheckoutExperimentVariant.TARGET_ONE),
      isTargetTwoCheckoutVariant: is(CheckoutExperimentVariant.TARGET_TWO),
      isTargetThreeCheckoutVariant: is(CheckoutExperimentVariant.TARGET_THREE),
    };
  }, [variant]);
};

export default useCheckoutFlowVariant;
